import { render, staticRenderFns } from "./BulkSMS.vue?vue&type=template&id=4ef3b4d5&scoped=true&"
import script from "./BulkSMS.vue?vue&type=script&lang=js&"
export * from "./BulkSMS.vue?vue&type=script&lang=js&"
import style0 from "./BulkSMS.vue?vue&type=style&index=0&id=4ef3b4d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef3b4d5",
  null
  
)

component.options.__file = "BulkSMS.vue"
export default component.exports